/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  MenuItem,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  dispatchErrorMsgActLabeler,
  dispatchPerformResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRebateProgramName,
  dispatchContacts,
  getContactsDropdown,
  dispatchContactsDropdownName,
  getActiveLabeler,
  showNoDataMessage,
  dispatchDisplayObjLabel,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';

import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

const ActiveLabeler = (props) => {
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,

    rebateProgramName: getRebateProgramName,
    errorMsgActLabel: getErrorMsg,
    contactsValue,
    contactsDrop: getContactsDropList,
    contactsDropValue,
    activeLabel: getActiveLabelList,
  } = useSelector((state) => state?.sharedState?.ActiveReducer);

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [radioList, setRadioList] = React.useState([]);
  const gridRef = useRef();
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [contactCategory, setContactCategory] = React.useState();
  const [contacts, setContacts] = React.useState(contactsValue);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          contactCategorySelected: contactsDropValue,
        }
  );

  // dispatch function
  const setPerformActiveScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformActiveScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  React.useEffect(()=> {
    dispatch(dispatchErrorMsgActLabeler([]));
  }, [state.planTypeCd, state.rebateProgramCd, contacts, state.contactCategorySelected])

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformActiveScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformActiveScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd' && item.field != 'noData');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgActLabeler(unique));
  };

  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgActLabeler(unique));
  };
  // Rebate programe error on plan type change
  React.useEffect(() => {
    handleOnblurEvent('rebateProgramCd', '1');
  }, [state.planTypeCd]);
  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/activeLabeler', true);
    } else {
      tabHighLigther('/activeLabeler', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  const contactType = state?.contactCategorySelected || '';

  const trimData = contactType?.split('-');
  const contactShort = trimData[0]?.trim();

  // Search button on click functionality
  const onClickOnSearch = () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = getErrorMsg || [];

    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgActLabeler(unique));
    if (localErr.length == 0) {
      setSearchClicked(true);
      dispatch(
        getActiveLabeler({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
          alAll: contacts == 'Invoice' ? 0 : 1,
          contactTypeCd: contacts == 'Invoice' ? 'ALL' : contactShort,
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchContacts({ contactsValue: contacts }));
      dispatch(
        dispatchContactsDropdownName({
          contactsDropValue: state?.contactCategorySelected,
        })
      );
      dispatch(
        dispatchDisplayObjLabel({
          rebateProgramName,
          contactsValue: contacts,
          contactsDropValue: state?.contactCategorySelected,
        })
      );
    }
  };
  if (
    isSearchClicked &&
    getActiveLabelList?.activeLabelersReportVO?.length > 0
  ) {
    setSearchClicked(false);
    redirectURLLink(
      '/displayActiveLabeler',
      'Display Active Labeler',
      props.history
    );
    dispatch(clearReduxForFilterAndSort('/displayActiveLabeler'));
  }
  // contacts dropdown
  React.useEffect(() => {
    const data1 =
      getContactsDropList?.activeLabelersVO?.map((item) => {
        return {
          ...item,
          name: `${item.contactTypeCd}-${item.shortDescr}`,
          id: `${item.contactTypeCd}-${item.shortDescr}`,
        };
      }) || [];

    setState({
      ...state,
      contactCategorySelected: contactsDropValue || data1[0]?.name,
    });
    setContactCategory(data1);
  }, [getContactsDropList]);
  React.useEffect(() => {
    dispatch(getContactsDropdown({}));
  }, []);

  return (
    <div
      className="tabs-container  tBillPanel custom-check"
      data-testid="active-labeler"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="State Reports" parent2="Active Labeler" />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          }
        />
      ) : null}
      <div className="tab-body">
        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="radio-button-for-rcdd"
              id="radio-button-for-rcdd_id"
              labelName="Plan Type"
              required
              optionList={radioList || []}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4 frr-two-col-radio ">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program<span className="mandatory"> *</span>
              </legend>
              <div className="form-wrapper p-3">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    name="rebateProgram"
                    id="rebate_program"
                    label="Rebate Program"
                    data-testid="req-NDC-payment-quarter"
                    fullWidth
                    select
                    required
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    value={
                      state && state.rebateProgramCd
                        ? state.rebateProgramCd
                        : ''
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>

          <div className="col-md-4">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">Contacts</legend>

              <div className="mui-custom-form with-select field-xl no-lbl">
                <RadioGroup
                  row
                  name="report-quarter"
                  data-testid="radio-btn-qtr"
                  required
                  value={contacts}
                  onChange={(e) => {
                    setContacts(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="Invoice"
                    control={<Radio />}
                    label="Invoice Contact for Control"
                  />
                  <FormControlLabel
                    value="Contact"
                    control={<Radio />}
                    label="Contact Type"
                  />
                </RadioGroup>
              </div>
              {contacts == 'Contact' && (
                <div className="mui-custom-form ">
                  <TextField
                    name="conatctType"
                    id="contact_type"
                    data-testid="Act-lab-contact-type"
                    fullWidth
                    select
                    required
                    inputProps={{ maxLength: 11, id: 'contact_type' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      setState({
                        ...state,
                        contactCategorySelected: e.target.value,
                      });
                    }}
                    value={
                      state && state.contactCategorySelected
                        ? state.contactCategorySelected
                        : ''
                    }
                  >
                    {contactCategory &&
                    contactCategory.length &&
                    contactCategory.length > 0
                      ? contactCategory.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              )}
            </fieldset>
          </div>
        </div>

        <div className="col-12 btn-wrapper mb-2">
          <div className="float-right mt-2 hide-on-print" tabIndex={0}>
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={onClickOnSearch}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveLabeler;
